import { FormatAlignCenter, FormatAlignLeft, FormatAlignRight } from "@mui/icons-material";
import { BaseWidget } from ".";
import { NumberControl } from "../controls/NumberControl";
import Filter1Icon from '@mui/icons-material/Filter1';
import { IconButtonGroupControl } from '../controls/IconButtonGroupControl';
import { ColorControl } from "../controls/ColorControl";
import { NumberCssControl } from "../controls/NumberCssControl";
import { SelectControl } from "../controls/SelectControl";
import MetricVisualization from "../../../dataVisualizations/MetricVisualization";

export class NumberWidget extends BaseWidget {
    
    getName() {
        return 'Nummer';
    }

    getIcon() {
        return <Filter1Icon />;
    }

    getControls() {
        return {
            'number': new NumberControl({
                label: 'Nummer',
                description: 'Het nummer om weer te geven',
                defaultValue: 1,
                // options: {
                //     step: 0.001
                // }
            }),
            'alignment': new IconButtonGroupControl({
                label: 'Tekstuitlijning',
                description: 'Uitlijning van de tekst',
                defaultValue: 'left',
                options: {
                    buttons: [
                        { 
                            value: 'left', 
                            icon: <FormatAlignLeft />, 
                            tooltip: 'Links' 
                        },
                        { 
                            value: 'center', 
                            icon: <FormatAlignCenter />, 
                            tooltip: 'Midden' 
                        },
                        { 
                            value: 'right', 
                            icon: <FormatAlignRight />, 
                            tooltip: 'Rechts' 
                        },
                    ]
                }
            }),
            'color': new ColorControl({
                label: 'Kleur',
                description: 'Kleur van de kop',
                defaultValue: '#000000',
            }),
            'fontSize': new NumberCssControl({
                label: 'Tekstgrootte',
                description: 'Grootte van het getal',
                defaultValue: { value: 64, unit: 'px' },
                options: { min: 8, max: 400, step: 1, units: ['px'] },
            }),
            'fontWeight': new SelectControl({
                label: 'Dikte',
                description: 'Dikte van het getal',
                defaultValue: 'normal',
                options: {
                    choices: [
                        { value: 'normal', label: 'Normaal' },
                        { value: 'bold', label: 'Vet' },
                        { value: 'bolder', label: 'Zwaarder' },
                        { value: 'lighter', label: 'Lichter' },
                    ],
                },
            }),
        };
    }

    /**
     * @param {{
     *     [K in keyof ReturnType<typeof this.getControls>]: ReturnType<typeof this.getControls>[K]['defaultValue']
     * }} props
     * @returns {React.ReactNode}
     */
    render(props) {
        return (
            <NumberRenderer
                {...props}
                fontSize={props.fontSize ? this.getCssValue(props.fontSize) : undefined}
            />
        );
    }
}

/**
 * Renders through the shared MetricVisualization so the number gets the exact
 * same box (padding, line-height) as the Output "Totaal" and Effect
 * "total-growth" numbers — equal font sizes then align vertically when the
 * widgets sit side by side in a report.
 *
 * @param {Parameters<NumberWidget['render']>[0] & { fontSize?: string }} props
 */
const NumberRenderer = ({ alignment, color, number, fontSize, fontWeight }) => {
    return <MetricVisualization
        value={number}
        align={alignment}
        valueStyle={{
            color: color,
            fontSize: fontSize || '64px',
            fontWeight: fontWeight,
        }}
    />;
};